// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__37yid","productName":"Table_productName__2Yw0g"};